import { render, staticRenderFns } from "./UserDayOverview.vue?vue&type=template&id=643a0f56&"
import script from "./UserDayOverview.vue?vue&type=script&lang=js&"
export * from "./UserDayOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserDayOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports